import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import * as crypto from 'crypto-js';
import { TranslateService } from '@ngx-translate/core';
import { EventsService } from './events.service';

@Injectable({
	providedIn: 'root'
})
export class ApiService {
	public auth_key: string = '';
	public code: string = `tt`;
	public key: string = `Um14Wm9QMw==`;
	public language: string = '';

	constructor(private http: HttpClient, public eventsService: EventsService) {
		this.eventsService.subscribe('update:language', async (language) => {
			this.language = language;
		});
	}

	setAuth(auth: any) {
		this.auth_key = auth;
	}

	get(url: string, data?: any) {
		let authorization = this.generateToken(new Date().getTime() / 1000, this.genRandomString(8));
		let headers = new HttpHeaders({
			'Content-Type': 'application/json',
			'360city-Authorization': `${this.code}:${authorization}`,
			'Accept-Language': this.language
			// 'X-AppGrupoPIE': `${environment.appName} v${environment.version}`
		});

		if (this.auth_key) {
			headers = headers.set('Authorization', this.auth_key);
		}

		let params = new HttpParams();

		if (data) {
			for (let p in data) {
				if (data[p]) {
					params = params.set(p, data[p]);
				}
			}
		}

		return this.http.get(environment.baseUrl + url, { headers: headers, params: params });
	}

	post(url: string, data: any) {
		let authorization = this.generateToken(new Date().getTime() / 1000, this.genRandomString(8));
		let headers = new HttpHeaders({
			'Content-Type': 'application/json',
			'360city-Authorization': `${this.code}:${authorization}`,
			'Accept-Language': this.language
			// 'X-AppGrupoPIE': `${environment.appName} v${environment.version}`
		});

		if (this.auth_key) {
			headers = headers.set('Authorization', this.auth_key);
		}

		return this.http.post(environment.baseUrl + url, data, { headers: headers });
	}

	generateToken(timestamp: number, randomString: string) {
		let auth_data_raw = timestamp + randomString;
		let auth_key_raw = this.decrypt(this.key);

		let hash = crypto.HmacSHA256(auth_data_raw, auth_key_raw);
		let hashString = crypto.enc.Base64.stringify(hash);
		let key = this.encrypt([timestamp, randomString, hashString].join(';'));

		return key;
	}

	encrypt(myString: string) {
		const encodedWord = crypto.enc.Utf8.parse(myString);
		const encoded = crypto.enc.Base64.stringify(encodedWord);
		return encoded;
	}

	decrypt(str: string) {
		return decodeURIComponent(
			atob(str)
				.split('')
				.map(function (c) {
					return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
				})
				.join('')
		);
	}

	genRandomString(length: number) {
		const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()';
		let result = '';
		for (let i = 0; i < length; i++) {
			result += chars.charAt(Math.floor(Math.random() * chars.length));
		}
		return result;
	}
}
